// Using Antd library 
import React, { useState } from 'react';
import { Select } from 'antd';

const FilteringDropdown = ({ name, options, selectedOptions, setSelectedOptions, setSearchValue, disabled }) => {

    const handleChange = (selected) => {
        setSelectedOptions(selected)
    }

    const handleSearch = (value) => {
        setSearchValue(value);
    };
    return (
        <Select style={{ width: '100%', minWidth: '200px', maxWidth: '820px' }}
            mode={'multiple'}
            autoClearSearchValue={false}
            placeholder={name}
            name={name}
            options={options}
            disabled={disabled}
            value={selectedOptions}
            tokenSeparators={[',', '\t']}
            onChange={handleChange}
            onSearch={handleSearch}
            showSearch
        />
    );
};

export default FilteringDropdown;